// extracted by mini-css-extract-plugin
export default {"container":"SliderLogicJumps_container__7N5bK","logicContainer":"SliderLogicJumps_logicContainer__rX1XV","addJumpButton":"SliderLogicJumps_addJumpButton__ianOK"};